// ============================================================================
// HOOK: useFileHubFeedback — Estados de feedback (error, notice, edgeInfo)
// ARQUIVO: src/hooks/useFileHubFeedback.js
// RESPONSABILIDADE: Isolar estados de feedback do FileHubArea.
// ============================================================================

import { useState, useEffect, useCallback } from "react";

export function useFileHubFeedback() {
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState(null);
  const [edgeInfo, setEdgeInfo] = useState(null);

  const showError = useCallback((msg) => setError(msg), []);
  const clearError = useCallback(() => setError(null), []);
  const showNotice = useCallback((msg) => setNotice(msg), []);
  const clearNotice = useCallback(() => setNotice(null), []);
  const showEdgeInfo = useCallback((msg) => setEdgeInfo(msg), []);
  const clearEdgeInfo = useCallback(() => setEdgeInfo(null), []);

  return {
    error, setError, showError, clearError,
    notice, setNotice, showNotice, clearNotice,
    edgeInfo, setEdgeInfo, showEdgeInfo, clearEdgeInfo,
  };
}

